import { styled } from '@mui/system';
import COLORS from '../../../theme/Colors';
import Button from '@mui/material/Button';
import { boxShadowConfig } from '../../../theme/Styles';
import FONTS_FAMILY from '../../../theme/FontsFamily';

export const Container = styled('div')({
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
});

export const ConfigLayoutContainer = styled('div')({
    display: 'flex',
    width: '100%',
    gap: '32px',
    marginTop: '24px',
    boxSizing: 'border-box',
    '@media (max-width:960px)': {
        flexDirection: 'column',
    },
});

export const ConfigSidebar = styled('div')({
    display: 'flex',
    flexDirection: 'column',
    gap: '8px',
    width: '280px',
    flexShrink: 0,
    backgroundColor: '#FFFFFF',
    borderRadius: '12px',
    padding: '16px',
    border: '1px solid rgba(198, 197, 208, 0.3)',
    boxShadow: 'none',
    boxSizing: 'border-box',
    '@media (max-width:960px)': {
        width: '100%',
        flexDirection: 'row',
        overflowX: 'auto',
        padding: '12px',
        whiteSpace: 'nowrap',
    },
    'html.dark &': {
        backgroundColor: '#0a0a0a',
        borderColor: '#222222',
    },
});

export const SidebarTabButton = styled('button')(({ active }) => ({
    display: 'flex',
    alignItems: 'center',
    gap: '12px',
    width: '100%',
    padding: '12px 16px',
    borderRadius: '8px',
    border: 'none',
    cursor: 'pointer',
    fontFamily: FONTS_FAMILY.bold.body,
    fontSize: '14px',
    fontWeight: active ? '600' : '500',
    backgroundColor: active ? 'rgba(3, 13, 57, 0.06)' : 'transparent',
    color: active ? '#192873' : '#5C5F6A',
    textAlign: 'left',
    transition: 'all 0.2s ease',
    position: 'relative',
    outline: 'none',
    '& svg': {
        color: active ? '#192873' : '#767680',
        fontSize: '20px',
    },
    '&::before': active ? {
        content: '""',
        position: 'absolute',
        left: '0',
        top: '20%',
        height: '60%',
        width: '3px',
        borderRadius: '0 2px 2px 0',
        backgroundColor: '#B7102A',
    } : {},
    '&:hover': {
        backgroundColor: active ? 'rgba(3, 13, 57, 0.06)' : 'rgba(3, 13, 57, 0.03)',
        color: '#192873',
        '& svg': {
            color: '#192873',
        }
    },
    '@media (max-width:960px)': {
        width: 'auto',
        display: 'inline-flex',
        padding: '10px 16px',
        '&::before': {
            display: 'none',
        },
    },
    'html.dark &': {
        backgroundColor: active ? 'rgba(37, 99, 235, 0.15)' : 'transparent',
        color: active ? '#ffffff' : '#94a3b8',
    },
    'html.dark & svg': {
        color: active ? '#ffffff' : '#94a3b8',
    },
    'html.dark &:hover': {
        backgroundColor: active ? 'rgba(37, 99, 235, 0.15)' : 'rgba(255, 255, 255, 0.05)',
        color: '#ffffff',
    },
    'html.dark &:hover svg': {
        color: '#ffffff',
    },
}));

export const SettingsPanel = styled('div')({
    flex: 1,
    backgroundColor: '#FFFFFF',
    borderRadius: '12px',
    padding: '32px',
    border: '1px solid rgba(198, 197, 208, 0.3)',
    boxShadow: 'none',
    boxSizing: 'border-box',
    minHeight: '400px',
    '@media (max-width:600px)': {
        padding: '20px',
    },
    'html.dark &': {
        backgroundColor: '#0a0a0a',
        borderColor: '#222222',
    },
});

export const TopContainer = styled('div')({
    position: 'relative',
    display: 'flex',
    minHeight: '120px',
    width: '100%',
    alignItems: 'center',
    justifyContent: 'space-between',
    marginBottom: '24px',
    '@media (max-width:768px)': {
        flexDirection: 'column',
        alignItems: 'flex-start',
        gap: '20px',
    },
});

export const UserDataContainer = styled('div')({
    display: 'flex',
    alignItems: 'center',
    gap: '20px',
    '@media (max-width:600px)': {
        flexDirection: 'column',
        alignItems: 'center',
        textAlign: 'center',
        width: '100%',
    },
});

export const ProfileImage = styled('img')({
    width: '100px',
    height: '100px',
    borderRadius: '50%',
    border: '3px solid #dee8ff',
    objectFit: 'cover',
    boxShadow: '0 4px 10px rgba(3, 13, 57, 0.1)',
});

export const Title = styled('h1')({
    fontFamily: FONTS_FAMILY.bold.title,
    textAlign: 'left',
    fontSize: '24px',
    fontWeight: '700',
    color: '#192873',
    margin: '0 0 4px 0',
    'html.dark &': {
        color: '#ffffff',
    },
});

export const SessionRow = styled('div')({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: '16px',
    borderRadius: '8px',
    border: '1px solid #E2E8F0',
    backgroundColor: '#F8F9FD',
    marginBottom: '12px',
    boxSizing: 'border-box',
    '&:last-child': {
        marginBottom: 0,
    },
    'html.dark &': {
        backgroundColor: '#111111',
        borderColor: '#222222',
    },
});

export const SessionInfo = styled('div')({
    display: 'flex',
    alignItems: 'center',
    gap: '16px',
});

export const SessionDetails = styled('div')({
    display: 'flex',
    flexDirection: 'column',
    gap: '2px',
});

export const ButtonSaveContainer = styled('div')({
    alignSelf: 'flex-start',
    width: '200px',
    marginTop: '24px',
    boxSizing: 'border-box',
    '@media (max-width:600px)': {
        width: '100%',
    },
});

export const Column = styled('div')({
    display: 'flex',
    flexDirection: 'column',
    gap: '12px',
    width: '100%',
});

export const ElementDivider = styled('div')({
    width: '10px'
});

export const ConfigTabsContainer = styled('div')({
    display: 'flex',
    gap: '8px',
    borderBottom: '1px solid #E2E8F0',
    marginBottom: '28px',
    width: '100%',
    overflowX: 'auto',
    whiteSpace: 'nowrap',
    '&::-webkit-scrollbar': {
        height: '4px',
    },
    '&::-webkit-scrollbar-thumb': {
        backgroundColor: '#CBD5E1',
        borderRadius: '4px',
    },
});

export const ConfigTabButton = styled('button')(({ active }) => ({
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    padding: '12px 20px',
    cursor: 'pointer',
    fontFamily: FONTS_FAMILY.bold.body,
    fontSize: '14px',
    fontWeight: active ? '700' : '500',
    backgroundColor: 'transparent',
    color: active ? '#192873' : '#5C5F6A',
    border: 'none',
    borderBottom: active ? '3px solid #B7102A' : '3px solid transparent',
    transition: 'all 0.15s ease',
    outline: 'none',
    boxSizing: 'border-box',
    marginBottom: '-1px', // overlaps the parent borderBottom
    '& svg': {
        color: active ? '#192873' : '#767680',
        fontSize: '18px',
        transition: 'color 0.15s ease',
    },
    '&:hover': {
        color: '#192873',
        borderBottom: active ? '3px solid #B7102A' : '3px solid rgba(183, 16, 42, 0.3)',
        '& svg': {
            color: '#192873',
        }
    },
    'html.dark &': {
        color: active ? '#ffffff' : '#94a3b8',
    },
    'html.dark & svg': {
        color: active ? '#ffffff' : '#94a3b8',
    },
    'html.dark &:hover': {
        color: '#ffffff',
    },
    'html.dark &:hover svg': {
        color: '#ffffff',
    },
}));
